import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { clearSessionToken } from 'auth'

const propTypes = {}

const defaultProps = {}

function PasswordView() {
  const { logout } = useAuth0()

  function handleLogout() {
    clearSessionToken()
    logout({
      logoutParams: { returnTo: window.location.origin },
    }).catch(() => {})
  }

  return (
    <div className="password-view">
      <h1>Password</h1>
      <div className="card">
        <h2>Change password</h2>
        <p>
          Need to change your password? Log out of the platform and select
          "Forgot your password?" on the login screen to continue.
        </p>
        <button className="button-primary" onClick={handleLogout} type="button">
          Log out
        </button>
      </div>
    </div>
  )
}

PasswordView.propTypes = propTypes
PasswordView.defaultProps = defaultProps

export default React.memo(PasswordView)
